import Route from './events-routes'

export { Route }
export default { Route }
